module.exports = __webpack_public_path__ + "img/ic_country_serve_img3.1cb79b08.png";